import { render, staticRenderFns } from "./CertificateDelete.vue?vue&type=template&id=34334e34&"
import script from "./CertificateDelete.vue?vue&type=script&lang=js&"
export * from "./CertificateDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports